import React from 'react';
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import { IVehicleInspection } from '@/interfaces/order';
import { formatThaiDate } from '@/utils/dataUtils';

dayjs.extend(buddhistEra);

interface IProps {
  data?: IVehicleInspection;
}

const TM30 = ({ data }: IProps) => {
  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        padding: '20px',
        pageBreakBefore: 'always',
        fontSize: '16px',
      }}
    >
      {/* Header */}
      {data?.isCP && (
        <div
          style={{ textAlign: 'right', fontSize: '14px', marginBottom: '10px' }}
        >
          เอกสารควบคุม : F-PX-036
        </div>
      )}
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h2 style={{ margin: '5px 0', fontSize: '18px', fontWeight: 'bold' }}>
          {data?.isCP && 'บริษัท ซีพีเอฟ (ประเทศไทย) จำกัด (มหาชน)'}
          {!data?.isCP && (
            <div className="flex justify-center">
              <img src="/kemin_logo_black.webp" width={150} />
            </div>
          )}
        </h2>
        <h3 style={{ margin: '5px 0', fontSize: '16px', fontWeight: 'bold' }}>
          บันทึกการตรวจสภาพรถบรรทุกขนส่งวัตถุดิบและสารเสริม
        </h3>
        <p style={{ fontSize: '14px', margin: '5px 0' }}>
          (ทำเครื่องหมาย ✓ ลงในช่อง ☐ และใส่ข้อมูลในช่อง.................)
        </p>
      </div>

      {/* Section 1: Product Details */}
      <div style={{ marginBottom: '15px' }}>
        <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>
          1. รายละเอียดของสินค้า
        </p>
        <p style={{ marginBottom: '3px' }}>
          ชื่อสินค้า{' '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '200px',
            }}
          >
            {data?.productName || ''}
          </span>{' '}
          ชื่อ, บริษัทเจ้าของสินค้า{' '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '200px',
            }}
          >
            {data?.companyOwner || ''}
          </span>
        </p>
        <p>
          สินค้าส่งจากจังหวัด{' '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '300px',
            }}
          >
            {data?.fromProvince || ''}
          </span>
        </p>
      </div>

      {/* Section 2: Transportation */}
      <div style={{ marginBottom: '15px' }}>
        <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>2. ขนส่งโดย</p>
        <p style={{ marginBottom: '5px' }}>
          {data?.transportation === 'truck' ? '☑' : '☐'} รถบรรทุก{' '}
          {data?.transportation === 'ship' ? '☑' : '☐'} เรือ
        </p>
        <p style={{ marginBottom: '3px' }}>
          ทะเบียนรถ/ชื่อเรือ{' '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '200px',
            }}
          >
            {data?.vehicleNumber || ''}
          </span>{' '}
          ชื่อคนขับ{' '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '200px',
            }}
          >
            {data?.driverName || ''}
          </span>
        </p>
        <p style={{ marginBottom: '3px' }}>
          {data?.isCleanBeforeLoad ? '☑' : '☐'} ก่อนบรรทุกสินค้านี้
          พื้นบรรทุกสะอาดและแห้ง ไม่เคยบรรทุก สารเคมี, สัตว์/ซากสัตว์, ของเสีย,
          ปุ๋ย
        </p>
        <p style={{ marginBottom: '3px', marginLeft: '20px' }}>
          ดิน, หิน, แร่, แร่ใยหิน, หนังฟอกย้อม, เศษโลหะ, เศษยาง, เศษแก้ว,
          เมล็ดธัญพืชที่คลุกสารเคมี, ยาฆ่าแมลง
        </p>
        <p style={{ marginBottom: '10px' }}>
          {data?.isCoveredAfterLoad ? '☑' : '☐'} หลังขึ้นสินค้าเสร็จ
          ได้คลุมสินค้ามิดชิดเรียบร้อย
        </p>
        <p style={{ marginBottom: '3px' }}>
          ลงชื่อ{' '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '250px',
            }}
          >
            {data?.controllerName || ''}
          </span>{' '}
          ผู้ควบคุมขึ้นสินค้า (ประทับตราบริษัท, ถ้ามี)
        </p>
        <p>
          ({' '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '200px',
            }}
          >
            {data?.controllerName || ''}
          </span>{' '}
          ) วันที่{' '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {data?.controlDate ? dayjs(data.controlDate).format('DD') : ''}
          </span>
          {' / '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {data?.controlDate ? dayjs(data.controlDate).format('MM') : ''}
          </span>
          {' / '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '70px',
            }}
          >
            {data?.controlDate ? dayjs(data.controlDate).format('BBBB') : ''}
          </span>
        </p>
      </div>

      {/* Section 3: Transportation History */}
      <div style={{ marginBottom: '15px' }}>
        <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>
          3. ประวัติการขนส่ง
        </p>
        <p style={{ marginBottom: '5px' }}>
          พาหนะนี้เคยบรรทุกขนส่งสินค้าไปยังที่อื่นๆก่อนหน้านี้ 3 ครั้ง คือ
        </p>

        {data?.driverHistories?.map((c, i) => {
          return (
            <div key={i + 1}>
              <p style={{ marginBottom: '2px' }}>
                ขนส่งครั้งที่ 1 ชื่อสินค้า{' '}
                <span
                  style={{
                    borderBottom: '1px dotted black',
                    display: 'inline-block',
                    minWidth: '150px',
                  }}
                >
                  {c.productName || ''}
                </span>{' '}
                ชื่อสถานที่ส่ง{' '}
                <span
                  style={{
                    borderBottom: '1px dotted black',
                    display: 'inline-block',
                    minWidth: '200px',
                  }}
                >
                  {c.addressName || ''}
                </span>
              </p>
              <p style={{ marginBottom: '5px' }}>
                ที่อยู่ (จังหวัด){' '}
                <span
                  style={{
                    borderBottom: '1px dotted black',
                    display: 'inline-block',
                    minWidth: '150px',
                  }}
                >
                  {c?.province || ''}
                </span>{' '}
                ส่งเมื่อวันที่{' '}
                <span
                  style={{
                    borderBottom: '1px dotted black',
                    display: 'inline-block',
                    minWidth: '200px',
                  }}
                >
                  {c?.deliveryDate ? formatThaiDate(c.deliveryDate) : ''}
                </span>
              </p>
            </div>
          );
        })}
        {data?.driverHistories?.length == 1 && (
          <>
            <p style={{ marginBottom: '2px' }}>
              ขนส่งครั้งที่ 2 ชื่อสินค้า{' '}
              <span
                style={{
                  borderBottom: '1px dotted black',
                  display: 'inline-block',
                  minWidth: '150px',
                }}
              >
                {data?.trip2ProductName || ''}
              </span>{' '}
              ชื่อสถานที่ส่ง{' '}
              <span
                style={{
                  borderBottom: '1px dotted black',
                  display: 'inline-block',
                  minWidth: '200px',
                }}
              >
                {data?.trip2Destination || ''}
              </span>
            </p>
            <p style={{ marginBottom: '5px' }}>
              ที่อยู่ (จังหวัด){' '}
              <span
                style={{
                  borderBottom: '1px dotted black',
                  display: 'inline-block',
                  minWidth: '150px',
                }}
              >
                {data?.trip2Province || ''}
              </span>{' '}
              ส่งเมื่อวันที่{' '}
              <span
                style={{
                  borderBottom: '1px dotted black',
                  display: 'inline-block',
                  minWidth: '200px',
                }}
              >
                {data?.trip2Date ? formatThaiDate(data.trip2Date) : ''}
              </span>
            </p>
          </>
        )}
        {/* Trip 3 */}
        {(data?.driverHistories?.length ?? 0) < 3 && (
          <>
            <p style={{ marginBottom: '2px' }}>
              ขนส่งครั้งที่ 3 ชื่อสินค้า{' '}
              <span
                style={{
                  borderBottom: '1px dotted black',
                  display: 'inline-block',
                  minWidth: '150px',
                }}
              >
                {data?.trip3ProductName || ''}
              </span>{' '}
              ชื่อสถานที่ส่ง{' '}
              <span
                style={{
                  borderBottom: '1px dotted black',
                  display: 'inline-block',
                  minWidth: '200px',
                }}
              >
                {data?.trip3Destination || ''}
              </span>
            </p>
            <p style={{ marginBottom: '5px' }}>
              ที่อยู่ (จังหวัด){' '}
              <span
                style={{
                  borderBottom: '1px dotted black',
                  display: 'inline-block',
                  minWidth: '150px',
                }}
              >
                {data?.trip3Province || ''}
              </span>{' '}
              ส่งเมื่อวันที่{' '}
              <span
                style={{
                  borderBottom: '1px dotted black',
                  display: 'inline-block',
                  minWidth: '200px',
                }}
              >
                {data?.trip3Date ? formatThaiDate(data.trip3Date) : ''}
              </span>
            </p>
          </>
        )}
      </div>

      {/* Section 4: Certification */}
      <div style={{ marginBottom: '15px' }}>
        <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>
          4. ข้าพเจ้า ขอรับรองว่า (ทำเครื่องหมาย ✓ ลงในช่อง ☐ ที่มีการปฏิบัติ)
        </p>
        <p style={{ marginBottom: '3px' }}>
          {data?.neverCarriedHazardous ? '☑' : '☐'}{' '}
          ก่อนหน้านี้จะบรรทุกสินค้านี้ ไม่เคยบรรทุกดิน หรือหิน หรือทราย
          หรือยาฆ่าแมลง หรือสารเคมีที่เป็นอันตราย
        </p>
        <p style={{ marginBottom: '3px' }}>
          {data?.vehicleCleaned ? '☑' : '☐'} ก่อนหน้าที่จะบรรทุกสินค้าล็อตนี้
          ได้มีการทำความสะอาดพื้นรถบรรทุกสินค้าจนแห้งสะอาด และทำความสะอาด
        </p>
        <p style={{ marginBottom: '3px', marginLeft: '20px' }}>
          ตัวรถส่วนอื่นๆ จนปราศจากสิ่งสกปรกและกลิ่นอันน่ารังเกียจเรียบร้อยแล้ว
        </p>
        <p style={{ marginBottom: '10px' }}>
          {data?.vehicleInGoodCondition ? '☑' : '☐'} รถบรรทุกอยู่ในสภาพสมบูรณ์
          ไม่มีการรั่วไหลของน้ำมันเชื้อเพลิง น้ำมันหล่อลื่น น้ำมันไฮดรอลิก
          และไม่มีคราบ
        </p>
        <p style={{ marginBottom: '3px', marginLeft: '20px' }}>
          น้ำมันบริเวณต่างๆของรถ
        </p>

        <p style={{ marginTop: '15px', marginBottom: '3px' }}>
          ลงชื่อ{' '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '250px',
            }}
          >
            {data?.ownerName || ''}
          </span>{' '}
          เจ้าของพาหนะหรือผู้มีอำนาจที่ได้รับมอบหมาย
        </p>
        <p>
          ({' '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '200px',
            }}
          >
            {data?.ownerName || ''}
          </span>{' '}
          ) วันที่{' '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {data?.ownerSignDate ? dayjs(data.ownerSignDate).format('DD') : ''}
          </span>
          {' / '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {data?.ownerSignDate ? dayjs(data.ownerSignDate).format('MM') : ''}
          </span>
          {' / '}
          <span
            style={{
              borderBottom: '1px dotted black',
              display: 'inline-block',
              minWidth: '70px',
            }}
          >
            {data?.ownerSignDate
              ? dayjs(data.ownerSignDate).format('BBBB')
              : ''}
          </span>
        </p>
      </div>

      {/* Footer */}
      {data?.isCP && (
        <div
          style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            fontSize: '12px',
            color: '#666',
          }}
        >
          เริ่มใช้วันที่ 1/10/2562
        </div>
      )}
    </div>
  );
};

export default TM30;
